export default function oembed() {
    const iframes = document.querySelectorAll('iframe')

    if (iframes) {
      // remove cookie from youtube and vimeo
      var trigger = function () {
          for (var i = 0; i < iframes.length; i++) {
            // get src from iframe
            var oldSrc = iframes[i].src;
            var url = new URL(oldSrc);
            let params = new URLSearchParams(url.search.slice(1));

            if (url.hostname === 'www.youtube.com') {
                url.hostname = 'www.youtube-nocookie.com';
                iframes[i].src = url.href;
            } else if (url.hostname === 'player.vimeo.com' && !params.has('dnt')) {
                url.searchParams.set('dnt', 1)
                iframes[i].src = url.href;
            }
          }
      };
      trigger();
    }
}